import React from "react";
import { connect } from "react-redux";
import Upload from "baseui/icon/upload.js";
import Plus from "baseui/icon/plus";
import Delete from "baseui/icon/delete";
import Check from "baseui/icon/check";
import { styled } from "baseui";
import {FaFolderOpen, FaFileAlt, FaCubes} from 'react-icons/fa';
import {
  createTemplateFolder,
  deleteTemplateFolder,
} from "../../redux/template/TemplateThunk";
import { TREE_ITEM_TYPES } from "../../constants/AppEnums";
import { hash, randomString } from "../../helpers/StringHelpers";
import { ROOT_FOLDER_PATH } from "../../constants/TemplatesConstants";
import {StatefulTooltip} from 'baseui/tooltip';



const FlexContainer = styled("div", ({ $theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  backgroundColor: $theme.colors.accent100,
  padding: "5px",
  borderRadius: "10px",
}));
const ButtonAnchor = styled("a", ({ $theme }) => ({
  cursor: "pointer",
  textDecoration: "none",
}));
function FolderButtonsGroupComponent(props) {
  return (
    <FlexContainer>
      <div>
      <ButtonAnchor
          onClick={() =>
            props.onAddNewTemplateFolder(undefined, {
              isEditing: true,
              name: "New Object",
              path: ROOT_FOLDER_PATH,
              type: TREE_ITEM_TYPES.OBJECT,
            })
          }
        >
          <FaCubes size={20} />
        </ButtonAnchor>  
        <StatefulTooltip>
        
        <ButtonAnchor
          onClick={() =>
            props.onAddNewTemplateFolder(undefined, {
              isEditing: true,
              name: "New File",
              path: ROOT_FOLDER_PATH,
              type: TREE_ITEM_TYPES.FILE,
            })
          }
        >
          <FaFileAlt size={20} />
        </ButtonAnchor>
        </StatefulTooltip>

        <ButtonAnchor
          onClick={() =>
            props.onAddNewTemplateFolder(undefined, {
              isEditing: true,
              name: "New Folder",
              path: ROOT_FOLDER_PATH,
              type: TREE_ITEM_TYPES.FOLDER,
            })
          }
        >
          <FaFolderOpen size={24} />
        </ButtonAnchor>
        {/* <ButtonAnchor>
          <Upload size={30} />
        </ButtonAnchor> */}
      </div>
      <div>
        <ButtonAnchor
          onClick={() => props.ondeleteTemplateFolder(props.selectedFolder.id)}
        >
          <Delete size={30} />
        </ButtonAnchor>
        {/* <ButtonAnchor>
          <Alert size={30} />
        </ButtonAnchor> */}
      </div>
    </FlexContainer>
  );
}

const mapStateToProps = (state) => {
  return {
    templateFolders: state.template.activeTemplate?.folders,
    selectedFolder: state.template.activeTemplate?.selectedFolder,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    ondeleteTemplateFolder: (folderId) => {
      dispatch(deleteTemplateFolder(folderId));
    },
    onAddNewTemplateFolder: (node, folder) => {
      dispatch(createTemplateFolder(node, folder));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FolderButtonsGroupComponent);
